import React from 'react';
import { Card, CardMedia, CardContent, Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { theme } from '../styles/theme';

const ProductCard = ({ product }) => {
  const navigate = useNavigate();
  
  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ position: 'relative', height: '200px', overflow: 'hidden' }}>
        <CardMedia
          component="img"
          sx={{
            height: '100%',
            width: '100%',
            objectFit: 'contain',
            display: 'block',
          }}
          image={product.image}
          alt={product.name}
        />
      </Box>
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography gutterBottom variant="h5" component="h2" sx={{ color: theme.palette.primary.main }}>
          {product.name}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {product.description}
        </Typography>
        <Typography variant="h6" sx={{ color: theme.palette.secondary.main, mb: 2 }}>
          {product.price}
        </Typography>
        <Button
          variant="contained"
          sx={{ bgcolor: theme.palette.primary.main }}
          onClick={() => navigate('/ordersuccess')}
        >
          Buy Now
        </Button>
      </CardContent>
    </Card>
  );
};

export default ProductCard;